import { createContext } from 'react';

export enum AlertOnHide {
    onlyClose = 1,
    goToHome,
    custom,
    reload,
}

export enum AlertType {
    error,
    info,
}

export type InitialAlertType = {
    alertMessage: {
        showModal: boolean;
        alertTitle: string;
        alertTxt: string;
        alertType: AlertType;
        onHide: AlertOnHide;
        onHideCustom: any;
        buttonName?: string;
        onHideSecondary?: AlertOnHide;
        onHideCustomSecondary?: any;
        buttonNameSecondary?: string;
        doBig?: boolean;
        doHTML?: boolean;
    };
};

export const initialAlertState = {
    alertMessage: {
        showModal: false,
        alertTitle: '',
        alertTxt: '',
        alertType: AlertType.info,
        onHide: AlertOnHide.onlyClose,
        onHideCustom: undefined,
        buttonName: 'OK',
        onHideSecondary: undefined,
        onHideCustomSecondary: undefined,
        buttonNameSecondary: undefined,
        doBig: false,
    },
};

const AlertContext = createContext<{
    alertstate: InitialAlertType;
    alertdispatch: React.Dispatch<any>;
}>({
    alertstate: initialAlertState,
    alertdispatch: () => null,
});

export default AlertContext;
